import React from "react";
import {
  Box,
  Grid,
  TextField,
  IconButton,
  InputAdornment
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useFormik } from "formik";
import * as Yup from "yup";
import BasicModal from "../../components/BasicModal";
import FormModalActions from "../../components/FormModalActions";
import {
  DENSE_FIELD_PROPS,
  DENSE_FORM_BODY_SX,
  FORM_MODAL_CONTENT_SX,
} from "../../utils/formModalStyles";
import { updateAttendance } from "../../services/attendanceService"; // Your service
import { useSelector } from 'react-redux'; // Import useSelector
import { getDoctorByUserId } from "../../services/doctorService"; // Import the service
import { getStaffByUserId } from "../../services/StaffService"; // Import the service

const validationSchema = Yup.object({
//   checkInTime: Yup.string().required("Check In Time is required"),
//   checkOutTime: Yup.string().required("Check Out Time is required"),
});

const EditAttendanceModal = ({ open, onClose, attendanceInfo }) => {
  const user = useSelector((state) => state.user.user); // Access user from Redux
  
  const getTimeString = (datetimeStr) => {
    const date = new Date(datetimeStr);
    return date.toTimeString().slice(0, 5); // returns "HH:mm"
  };

  const formik = useFormik({
    initialValues: {
      checkInTime: attendanceInfo.checkInTime ? getTimeString(attendanceInfo.checkInTime) : "",
      checkOutTime: attendanceInfo.checkOutTime ? getTimeString(attendanceInfo.checkOutTime) : "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      try {
                    // Fetch user details based on user.id
                        let userDetails;
                        if (user.roleName === "doctor" || user.roleName === "surgeon") {
                          userDetails = await getDoctorByUserId(user.id); // Fetch doctor details
                        } else {
                          userDetails = await getStaffByUserId(user.id); // Fetch staff details
                        }
        await updateAttendance(attendanceInfo.attendanceId, {
          attendanceDate: attendanceInfo.attendanceDate,
          // checkInTime: values.checkInTime,   // format to HH:mm
          checkInTime: attendanceInfo.checkInTime,   // format to HH:mm
          checkOutTime: values.checkOutTime,
          status: "PRESENT",
          remarks: "present",
          ...(user?.roleName === 'doctor' 
            ? { doctorId: userDetails.id }
            : { staffId: userDetails.id }
          )
        });
        alert("Attendance updated successfully!");
        handleClose();
      } catch (error) {
        console.error("Error updating attendance:", error);
        alert("Failed to update attendance.");
      }
    },
  });

  const handleClose = () => {
    formik.resetForm();  // ✅ Clear form values
    onClose();           // ✅ Trigger modal close
  };

  return (
    <BasicModal
      open={open}
      onClose={handleClose} // ✅ use wrapped handler
      title="Edit Attendance"
    >
      <Box sx={{ ...FORM_MODAL_CONTENT_SX, ...DENSE_FORM_BODY_SX }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Check In Time"
                type="time"
                name="checkInTime"
                // value={formik.values.checkInTime}
                value={attendanceInfo.checkInTime}
                // onChange={formik.handleChange}
                disabled // Disable the check-in time field
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={formik.touched.checkInTime && Boolean(formik.errors.checkInTime)}
                helperText={formik.touched.checkInTime && formik.errors.checkInTime}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => formik.setFieldValue("checkInTime", "")}
                        disabled // Disable the clear button as well
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                {...DENSE_FIELD_PROPS}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Check Out Time"
                type="time"
                name="checkOutTime"
                value={formik.values.checkOutTime}
                onChange={formik.handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={formik.touched.checkOutTime && Boolean(formik.errors.checkOutTime)}
                helperText={formik.touched.checkOutTime && formik.errors.checkOutTime}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => formik.setFieldValue("checkOutTime", "")}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                {...DENSE_FIELD_PROPS}
              />
            </Grid>
            <Grid item xs={12}>
              <FormModalActions
                onCancel={handleClose}
                submitType="submit"
                submitLabel="Update Attendance"
                submitDisabled={formik.isSubmitting}
                loading={formik.isSubmitting}
              />
            </Grid>
          </Grid>
        </form>
      </Box>
    </BasicModal>
  );
};

export default EditAttendanceModal;
